import {WdiModalAppProps} from "@/components/WdiControls";
import {TableColumnsType} from "antd";
import React, {useEffect} from "react";
import {WdiModal} from "@/components/WdiControls/WdiModalForm";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {FormApi} from "@/services/sales";
import {getFormUrlMapping} from "@/components/WdiBus/FormPage";
import DataStore from "@/components/GridWidget/DataStore";

const FormSpSelectApp: React.FC<WdiModalAppProps> = (props) => {
  const {data} = props;
  const [dataSource, setDataSource] = React.useState<string[]>([]);

  useEffect(() => {
    const dataSet = new Set<string>();
    if (data.formSp.reversePrepayDetail) {
      data.formSp.reversePrepayDetail.split(",").map((tpmDetail: any) => {
        const tpmNos = tpmDetail.split("-");
        if (tpmNos && tpmNos.length > 0) {
          dataSet.add(tpmNos[0]);
        }
      });
    }
    const array = Array.from(dataSet).map((item) => ({formSpNo: item}));
    setDataSource(DataStore.init(array));
    if (array.length == 1) {
      FormApi.getByFormNo(array[0].formSpNo).then(response => {
        if (response.data) {
          const form = response.data;
          window.open(getFormUrlMapping(form.pageTypeId, form.formTypeId) + `?formId=${form.formId}&pageTypeId=${form.pageTypeId}&formTypeId=${form.formTypeId}`);
          props.onClose?.();
        }
      })
    }
  }, []);

  const columns: TableColumnsType = [
    {
      title: '预付单',
      dataIndex: 'formSpNo',
      ellipsis: true,
      render: (value) => (
        <a onClick={() => {
          FormApi.getByFormNo(value).then(response => {
            if (response.data) {
              const form = response.data;
              window.open(getFormUrlMapping(form.pageTypeId, form.formTypeId) + `?formId=${form.formId}&pageTypeId=${form.pageTypeId}&formTypeId=${form.formTypeId}`);
            }
          })
        }}>{value}
        </a>),
    },
  ];
  return (
    <WdiModal
      title={props.title}
      visible={props.visible}
      width={500}
      onCancel={() => {
        props.onClose?.()
      }}
      onOk={() => {
        props.onClose?.()
      }}>
      <WdiTable
        showPageRows={10}
        columns={columns}
        size='small'
        dataSource={dataSource}
        pagination={false}
      />
    </WdiModal>
  )
}
export default FormSpSelectApp;
